export default "__VITE_ASSET__B6Y7ol9U__"